import { styled } from '@mui/material/styles';
import Link from 'next/link';
import { Box, Toolbar, Button } from '@mui/material';

export const StyledToolbar = styled(Toolbar)({
  height: '70px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 !important',
  width: '100%'
});

export const NavSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  position: 'relative',
});

export const UserSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const LogoSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  marginRight: '24px',
  cursor: 'pointer'
});

interface NavLinkProps {
  href: string;
  isActive: boolean;
}

export const NavLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})<NavLinkProps>(({ isActive }) => ({
  color: isActive ? '#2563eb' : 'white',
  backgroundColor: isActive ? 'rgba(255, 255, 255, 0.9)' : 'transparent',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 20px',
  textDecoration: 'none',
  fontSize: '16px',
  fontWeight: 500,
  minWidth: '8rem',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  transition: 'all 0.3s ease',
  position: 'relative',
  '&:hover': {
    backgroundColor: isActive ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.15)',
    color: isActive ? '#1d4ed8' : 'white',
  },
  '&::after': isActive ? {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: '10%',
    width: '80%',
    height: '3px',
    backgroundColor: '#2563eb',
    borderRadius: '2px 2px 0 0'
  } : {}
}));

export const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive: boolean }>(({ isActive }) => ({
  color: isActive ? '#2563eb' : 'white',
  backgroundColor: isActive ? 'rgba(255, 255, 255, 0.9)' : 'transparent',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 20px',
  textDecoration: 'none',
  fontSize: '16px',
  fontWeight: 500,
  minWidth: '8rem',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  transition: 'all 0.3s ease',
  position: 'relative',
  textTransform: 'none',
  borderRadius: 0,
  '&:hover': {
    backgroundColor: isActive ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.15)',
    color: isActive ? '#1d4ed8' : 'white',
  },
  '&::after': isActive ? {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: '10%',
    width: '80%',
    height: '3px',
    backgroundColor: '#2563eb',
    borderRadius: '2px 2px 0 0'
  } : {}
}));